
import ChartSquare from "../../../assets/filled/ChartSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ChartSquareIcon({ className, dataTestid = "ChartSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ChartSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
